import { render, staticRenderFns } from "./KycDetailsFiles.vue?vue&type=template&id=5e69a6cd&scoped=true&"
import script from "./KycDetailsFiles.vue?vue&type=script&lang=js&"
export * from "./KycDetailsFiles.vue?vue&type=script&lang=js&"
import style0 from "./KycDetailsFiles.vue?vue&type=style&index=0&id=5e69a6cd&scoped=true&lang=css&"
import style1 from "./KycDetailsFiles.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e69a6cd",
  null
  
)

export default component.exports